import type { SegmentAnalyticsPlugin } from "./definitions"

declare const SegmentAnalytics: SegmentAnalyticsPlugin
// eslint-disable-next-line import/export -- inlined package "SegmentAnalyticsPlugin"
export * from "./definitions"
export { SegmentAnalytics }
